/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ branch: NonNullable<unknown> }} Users_Form_Branches_RemoveInputs */

const en_users_form_branches_remove = /** @type {(inputs: Users_Form_Branches_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.branch}`)
};

const pt_br2_users_form_branches_remove = /** @type {(inputs: Users_Form_Branches_RemoveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remover ${i?.branch}`)
};

/**
* | output |
* | --- |
* | "Remove {branch}" |
*
* @param {Users_Form_Branches_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_branches_remove = /** @type {((inputs: Users_Form_Branches_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Branches_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_branches_remove(inputs)
	return pt_br2_users_form_branches_remove(inputs)
});